import React, { ReactElement } from 'react';
import { Control, DeepMap, FieldError } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { ControlledCheckbox } from '../../../../../components';
import { RemoteAccessFormLoader } from '../RemoteAccessFormLoader';
import styles from './RemoteAccessForm.module.css';
import { DhcpOptionFormFields } from './components/DhcpOptionFormFields/DhcpOptionFormFields.tsx';

export interface RemoteAccessFormProps {
  control: Control<RemoteAccessFormData>;
  errors: DeepMap<RemoteAccessFormData, FieldError>;
  watch: (arg: string) => string | boolean;
  trigger: (
    name?:
      | keyof RemoteAccessFormData
      | (keyof RemoteAccessFormData)[]
      | undefined,
  ) => Promise<boolean>;
  isDhcpOption43Enabled: boolean;
  isEndpointKitEnabled: boolean;
  isFetching: boolean;
}

enum LabelKeys {
  AnyconnectEnabled = 'anyconnectEnabled',
  EndpointKitEnabled = 'endpointKitEnabled',
}

const translationKey = (key: LabelKeys): string =>
  `remoteAccess.formLabels.${key}`;

export function RemoteAccessForm({
  control,
  watch,
  errors,
  trigger,
  isFetching,
  isDhcpOption43Enabled,
  isEndpointKitEnabled,
}: RemoteAccessFormProps): ReactElement {
  const { t } = useTranslation();

  if (isFetching) {
    return <RemoteAccessFormLoader />;
  }
  const dhcpOptionClass = classNames({
    ['displayNone']: !isEndpointKitEnabled,
  });

  return (
    <form className={styles.root}>
      <ControlledCheckbox
        control={control}
        id={LabelKeys.AnyconnectEnabled as string}
        label={t(translationKey(LabelKeys.AnyconnectEnabled))}
      />
      <ControlledCheckbox
        control={control}
        id={LabelKeys.EndpointKitEnabled as string}
        label={t(translationKey(LabelKeys.EndpointKitEnabled))}
      />
      <div className={dhcpOptionClass}>
        <ControlledCheckbox
          control={control}
          id="dhcpOption43Enabled"
          label={t('remoteAccess.formLabels.dhcpOption43Enabled')}
        />
        <DhcpOptionFormFields
          control={control}
          watch={watch}
          errors={errors}
          trigger={trigger}
          isDhcpOption43Enabled={isDhcpOption43Enabled}
        />
      </div>
    </form>
  );
}
